import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  en: {
    translation: {
      sidebar: {
        home: "Home",
        skills: "Skills",
        projects: "Projects",
        contact: "Contact",
        job: "full stack developer",
      },
      home: {
        me: "Hello, It's Me",
        name: "Karim AIT EL DJOUDI",
        job: "I’m a full stack Developer",
        details:
          "I have acquired solid experience in creating innovative and effective software solutions to meet customer needs. With over 3 years' experience in full stack development, I have expertise in creating websites, web applications and online platforms from scratch.",
        donwload: "Donwload CV",
      },
      skills: {
        formation: {
          title: "Education",
          university: {
            school: "Paris 8 University",
            master: "Master of Computer Science",
            licence: "Bachelor's degree in computer science",
            licence1: "Bachelor's degree in Miashs",
          },
          bac: {
            school: "Seddouk technicum High school",
            bac: "Scientific baccalaureate (S)",
          },
        },
        experiences: {
          title: "Professional experiences",
          sanofi: {
            job: "Full Stack Developer Consultant",
            date: "{{ date }}",
            address: "Vitry-sur-Seine, Île-de-France, France",
          },
          ls: {
            job: "Full Stack Developer",
            contract: "Open-ended contract",
            contract1: "Apprenticeship contract",
            contract2: "Internship",
            date: "{{ date }}",
            address: "Fontenay-aux-Roses, Île-de-France, France",
          },
          buffalo: {
            job: "Web Developer",
            contract: "Buffalo Grill - Apprenticeship contract",
            date: "{{ date }}",
            address: "Montrouge, Île-de-France, France",
          },
          franprix: {
            job: "Part-time salesman (student job)",
            contract:
              "Franprix - Groupe Casino - Part-time Open-ended contract",
            date: "{{ date }}",
            address: "Paris, Île-de-France, France",
          },
        },
        competencies: {
          title: "Competencies",
          languages: {
            title: "Programming Languages",
          },
          frameworks: {
            title: "Frameworks & tools",
          },
          infras: {
            title: "CI/CD & Infrastructure",
          },
          databases: {
            title: "Databases",
          },
          tests: {
            title: "Test & Security",
          },
          projects: {
            title: "Project Management",
            agile: "Agile Method",
          },
        },
        languagePreferences: {
          languages: {
            title: "Languages",
            english: {
              title: "English",
              level: "Upper-Intermediate",
            },
            arabic: {
              title: "Arabic",
              level: "Fluent",
            },
            kabyle: {
              title: "Kabyle",
              level: "Native",
            },
          },
          system: {
            title: "OS preference",
          },
          certificate: {
            title: "Certificate",
          },
        },
        hobbies: {
          title: "interests",
          time: {
            primary: "I spend my free time working on personal projects",
            secondary:
              "I spend a lot of my free time developing projects that I'm passionate about. This allows me to learn new technologies and strengthen my skills while remaining creative.",
          },
          football: {
            primary: "Football",
            secondary:
              "Football is one of my favorite sports. I enjoy not only the physical aspect of the game, but also the strategy and team spirit involved.",
          },
          swimming: {
            primary: "Swimming",
            secondary:
              "Swimming is a great way for me to relax and keep fit. It's also a sport that requires discipline and perseverance.",
          },
        },
      },
      projects: {
        js: {
          variant: {
            info: "Variant Lifepipe is an innovative solution for analyzing and managing genomic data.\n\nI contributed to the development of this application using JavaScript, Node.js, and React. My responsibilities included integrating interactive features, optimizing performance, and collaborating with multidisciplinary teams to meet user needs.",
          },
          microbiome: {
            info: "Microbiome Lifepipe is a platform dedicated to analyzing microbiological data.\n\nI participated in the development of this application using JavaScript, Node.js, and React, focusing on implementing intuitive front-end features and managing data flows efficiently.\n\nThis project allowed me to collaborate with bioinformatics experts to provide powerful tools tailored to researchers.",
          },
          ngs: {
            info: "NGS Manager is an application for managing data from next-generation genomic sequencing.\n\nI worked on this project by contributing to the development of intuitive interfaces, managing complex data flows, and integrating collaborative features while optimizing performance for users.",
          },
          attendance: {
            info: "The **Attendance Management Client** project is the web interface developed for the **Attendance Management Server** project. It is a real-time facial recognition attendance management application for students.\n\nThe web application is served to administrators and includes a secure login page. Only authorized personnel, such as administrators, can access the attendance management interface.\n\nOnce logged in, administrators can view students present in real time, check each student's arrival time, and generate PDF reports detailing attendance for a specific date or for the current day.\n\nThe login page ensures that only authorized users can access these sensitive features, ensuring the confidentiality and security of data.",
          },
          procurement: {
            info: "The **Procurement Guide Client** project is the web interface developed for the **Procurement Guide Server** project. It allows users to submit reviews about products through a fictional e-commerce website. The results of review classification (positive or negative) are only accessible to administrators of the web application.\n\nDeveloped with React and JavaScript, the interface offers an intuitive user experience for submitting reviews, while the Flask API of the server processes and classifies these reviews in real-time using an SVM model.",
          },
          portfoliov2: {
            info: "Portfolio V2 is an improved and optimized version of my portfolio, developed with React and Material-UI. \n\nThis version features a modern, clean, and fully responsive design, providing an enhanced user experience. It highlights my projects, skills, and professional journey interactively, leveraging dynamic Material-UI components and smooth animations. \n\nThe code is structured for simplified and scalable maintenance, with modular styles based on SCSS for increased customization.",
          },
          portfoliov1: {
            info: "This project involves the creation of the beta version of my portfolio, developed with React and SCSS.\n\nThe application presents a modern and responsive interface to display my projects, skills, and professional background. It uses React for efficient user interface management and SCSS for flexible and organized styling.",
          },
          mincraft: {
            info: "This project involves a simplified version of Minecraft, developed with Three.js, a JavaScript library for creating 3D graphics.\n\nThe project allows a player to interact with a 3D map, placing or removing cubes of different colors and observing a dynamic day/night cycle with moving lighting.\n\nThis project explores the basics of 3D manipulation, light management, and user interactions to create an immersive experience inspired by Minecraft.",
          },
          panolanse: {
            info: "**Panolanse** is a JavaScript project aimed at creating an interactive viewer for 360-degree panoramic images.\n\nThe application allows users to freely navigate through panoramas by rotating and zooming using a mouse or touch interactions.\n\nThis project leveraged technologies like WebGL and graphics libraries to handle real-time image rendering, providing an immersive and smooth experience.",
          },
          kresus: {
            title: "Contribution to the Kresus Application",
            info: "**Kresus** is an open-source personal finance management application that allows users to track their expenses, organize their finances, and visualize their data through charts and reports.\n\nIn this project, my contribution was to add support for Spanish and Turkish languages by translating the user interface and key messages to make the application accessible to a wider audience.",
          },
          TRex: {
            info: "This project involves recreating the famous **T-Rex** game in JavaScript, inspired by the mini-game from the Google Chrome browser.\n\nThe game features a dinosaur that must avoid obstacles like cacti and birds by jumping or ducking. The goal is to achieve the highest score possible by surviving as long as possible.",
          },
          graphql: {
            title: "GraphQL",
            info: "This project involves discovering and practicing the concepts of GraphQL with JavaScript.\n\nIt includes creating a GraphQL server, defining schemas, queries, and mutations, as well as manipulating data.",
          },
        },
        py: {
          MetaPredictor: {
            info: "MetaPredictor is an application that predicts interactions between antibodies and MHC class I and II molecules.\n\nI contributed to the development of the backend API with FastAPI and the front-end with React, developing features to process and visualize prediction data effectively and intuitively.",
          },
          attendance: {
            info: "The **Attendance Management Server** project is an attendance management application using real-time facial recognition to register student attendance.\n\nThis part uses the dlib library for face detection and encoding, and OpenCV for capturing and displaying live images via a webcam. When a known face is detected, it is compared to those stored in a Firebase database. If the face is recognized, the name and registration time are added to the database, allowing attendance tracking.\n\nThe project also integrates with Firebase Storage to store images and data of registered faces, as well as real-time data management.",
          },
          procurement: {
            info: "The **Procurement Guide Server** project is a Flask application dedicated to managing and analyzing customer reviews.\n\nIt collects reviews from a Firebase database, preprocesses them by removing stop words and performing lemmatization, then classifies them using an SVM model.\n\nThe Flask API exposes endpoints to receive customer reviews, classify them (positive or negative), and return results through real-time predictions, facilitating customer feedback analysis.",
          },
          starcraft: {
            info: "In the **Starcraft with PySC2** project, I used the PySC2 API to interact with the game Starcraft II.\n\nThis project focuses on training artificial intelligence agents to play the game using reinforcement learning techniques. I created training environments and analyzed agent performance in various game scenarios.\n\nThe goal is to develop an AI capable of making strategic decisions in Starcraft II.",
          },
          covid: {
            title: "Covid Analysis",
            info: "In this project, I analyzed Covid-19 vaccination data using Python and several libraries like Pandas, Seaborn, Plotly, and Folium.\n\nI performed data cleaning, filled missing values, and created various visualizations such as vaccines used worldwide, vaccination by country, and prediction of the number of vaccinated people in France.\n\nThe project also includes the creation of interactive maps and the prediction of vaccination trends using the Prophet model.",
          },
          ia: {
            title: "Artificial Intelligence",
            info: "I developed several scripts in artificial intelligence and machine learning.\n\nThese scripts include implementations of algorithms like K-means for classification, solving logical problems like the farmer's problem, and using search algorithms like A* to find paths in simulated games. My work explores different optimization and search methods, applying these techniques to practical and theoretical problems to better understand and solve complex challenges.",
          },
          crypto: {
            title: "Cryptography",
            info: "This project focuses on cryptography and encryption/decryption of data using Python.\n\nI worked on security algorithms such as RSA and AES, emphasizing creating robust and secure methods to protect sensitive information. The project includes implementing several encryption techniques, with a focus on efficiency and ease of use.",
          },
          parser: {
            title: "XML Parser",
            info: "This Python project is a text processing script that reads a text file, cleans it, and transforms it into XML format.\n\nIt uses regular expressions to clean and format the text before converting it into distinct sentences and generating an XML output file.",
          },
          flask: {
            title: "Flask API",
            info: "This project involves learning how to create APIs with Flask, a Python micro-framework. It manages a list of books using a JSON file to store data.\n\nThe API exposes several routes to interact with this data through the following HTTP methods: GET to retrieve the list of books or a specific book, POST to add a new book, PUT to update an existing book, and DELETE to remove a book from the list.",
          },
        },
        ccplus: {
          tetris: {
            info: "This project involves implementing the Tetris game in C++.\n\nThe game follows the classic Tetris rules, where the player must arrange geometric shapes (called 'tetriminos') falling from the top of the screen to form complete lines, which are then removed.\n\nAs the player progresses, the level changes dynamically, altering the shape of the game matrix, which can take various configurations such as a triangle, square, or rectangle. Additionally, the difficulty increases over time by speeding up the falling shapes, providing an additional challenge and making the experience more immersive.",
          },
          uno: {
            info: "This project involves implementing the UNO card game in C.\n\nThe game follows the classic UNO rules, where players must discard their cards by matching color or value, with the addition of special cards that modify the course of the game (such as 'Plus 2', 'Reverse', 'Skip', etc.).",
          },
          grenoble: {
            title: "Grenoble Tramway",
            info: "This project aims to implement a tramway route management system in the city of Grenoble, using the A* search algorithm to determine the shortest path between a departure station and an arrival station.\n\nThe goal is to provide an optimal route for a tram journey, considering different stations and possible stops, while minimizing the distance or travel time.",
          },
          antColony: {
            title: "Ant Colony",
            info: "This project implements an Ant Colony Optimization (ACO) algorithm in C, a technique inspired by the behavior of ants in nature to solve combinatorial optimization problems.\n\nThe goal is to simulate a colony of ants exploring an environment to find optimal solutions to complex problems, such as the traveling salesman problem (TSP).",
          },
          som: {
            title: "Kohonen SOM",
            info: "Self-organizing maps (SOM), also known as self-organizing feature maps or topological maps, form a class of artificial neural networks based on unsupervised learning methods.",
          },
          storage: {
            title: "Memory Storage",
            info: "This project was created to learn and understand memory management in C, specifically dynamic memory management, allocation, and resource deallocation.\n\nThe goal was to create a custom memory storage system that efficiently manages the allocation, reading, and freeing of memory blocks.",
          },
          graphique: {
            title: "Graphical Design",
            info: "These projects were created as part of learning to create graphical interfaces using GL4Dummies.",
          },
          LearCplus: {
            title: "Learn C/C++",
            info: "I developed a collection of algorithms and data structures implemented in C and C++.\n\nThis project was designed to strengthen my understanding of these languages by covering fundamental programming concepts such as memory management, pointers, and classic algorithms.\n\nEach file presents an algorithm or data structure with examples and detailed explanations, allowing users to learn and understand the basics of C and C++ through practical exercises.",
          },
        },
        java: {
          snake: {
            info: "A player controls a snake that grows each time it eats food.\n\nThe goal is to eat as much food as possible without hitting the walls or biting itself.",
          },
          quiz: {
            info: "This project is a quiz game developed in Kotlin.\nThe player can choose a quiz category and answer questions to earn points.\n\nIn this game, I used a Firebase database to store the questions and answers.",
          },
          som: {
            title: "Kohonen SOM",
            info: "This project involves developing a self-organizing map (SOM) in Java.\n\nThe focus is on the unsupervised learning algorithm to adjust neurons based on the data, allowing the model to evolve.",
          },
          springBoot: {
            info: "I worked on several mini-projects to test the integration of various solutions on the client side, server side, and at the database level.\n\nThe goal was to familiarize myself with different architectures and analyze the advantages and challenges of each technology.\n\nI worked mainly with Spring Boot for the backend, integrating it with relational databases like MySQL and NoSQL databases like MongoDB to test their ability to handle varied data streams and their efficiency in modern development environments.\n\nOn the client side, I compared two popular frameworks: React and Angular. These technologies allowed me to test different approaches to developing reactive and dynamic user interfaces.",
          },
        },
        other: {
          title: "Other",
          search: {
            info: "This project involves developing a search engine that analyzes different types of documents (HTML, TXT, PDF). When a user enters a keyword, the system identifies which files it appears in.\n\nThe project includes extracting metadata (keywords, description) and titles from documents, as well as breaking the text into elements.\n\nA size filter is applied to the elements, and the system calculates the occurrences of each word to improve result relevance. The data is stored in a MySQL database to facilitate file and result management.",
          },
          php: {
            title: "Angular with PHP",
            info: "This project was developed to learn and integrate Angular on the frontend and PHP on the backend, focusing on communication between these two technologies via RESTful APIs.\n\nThe goal was to understand how modern applications use Angular to create dynamic interfaces and how PHP can be used to provide data and interact with a MySQL database.",
          },
          smart: {
            title: "Smart Contracts",
            info: "This project was created to learn and understand smart contract development on the Ethereum blockchain using the Solidity language.\n\nThe goal was to familiarize myself with the fundamentals of smart contracts, their deployment on the blockchain, and interacting with these contracts through user interfaces and tools like Truffle and Metamask.",
          },
          native: {
            title: "React Native",
            info: "This project was designed to learn how to develop a mobile application with React Native.\n\nThe main goal was to create a simple app that allows users to sign in, create an account, and log out, with a focus on managing authentication and user state.",
          },
          assembly: {
            title: "Assembly",
            info: "These projects were designed to learn the basics of programming in Assembly.\n\nThe goal was to understand how to directly manipulate a computer's processor and memory, as well as perform simple operations like addition and subtraction at a low level.",
          },
        },
        button: "See more",
        linkButton: "Take a Look",
      },
      contact: {
        title: "Contact Us",
      },

      footer: {
        copyright: "© {{year}}.",
        legalNotice: "Legal notice",
        googleReviews: "Google Reviews",
      },
      legalNotice: {
        title: "Legal Notice",
        companyInfo: "Website editor",
        companyName: "Full Name : Karim AIT EL DJOUDI ",
        phone: "Phone : +33 769632389",
        email: "Email: aiteldjoudikarim06@gmail.com",
        /*----------------- Hébergeur ------------------*/
        host: "Host",
        hostDetails:
          "To ensure the reliability and security of our online services, we work with a trusted host. Here are the details of our host:",
        hostName: "Amazon Web Services (AWS)",
        hostAddress:
          "Amazon Web Services, Inc. 410 Terry Avenue North, Seattle, WA 98109-5210, États-Unis",
        hostPhone: "+1 206-266-4064",
        website: "https://aws.amazon.com",
        /*----------------- dataPolicy ------------------*/
        dataPolicy: "Data Policy",
        dataPolicyDetails:
          "On this site, we respect your privacy and take the protection of your personal data very seriously. We do not store any personal data.",
        copyRestrictions: "Copy Restrictions",
        copyRestrictionsDetails:
          "Intellectual property is a value we defend firmly. Any attempt to copy or reproduce our website, in whole or in part, constitutes a violation of our copyright and is strictly prohibited. Article L.335-2.",
        photoCredit: "Photo Credit",
        photoCreditDetails:
          "The images used on this site come from Freepik as well as logos and visuals from professional collaborations with companies and academic institutions, which remain the exclusive property of their owners. For any modification or deletion request, please contact me by e-mail. ",
      },
    },
  },

  fr: {
    translation: {
      sidebar: {
        home: "Accueil",
        skills: "Compétences",
        projects: "Projets",
        contact: "Contact",
        job: "développeur full stack",
      },
      home: {
        me: "Bonjour, c'est moi !",
        name: "Karim AIT EL DJOUDI",
        job: "Je suis un développeur full stack",
        details:
          "J'ai acquis une solide expérience dans la création de solutions logicielles innovantes et efficaces pour répondre aux besoins des clients. Avec plus de 3 ans d'expérience dans le développement full stack, j'ai une expertise dans la création de sites web, d'applications web et de plateformes en ligne.",
        donwload: "Télécharger CV",
      },
      skills: {
        formation: {
          title: "Formation",
          university: {
            school: "Université Paris 8",
            master: "Master Informatique",
            licence: "Licence Informatique",
            licence1: "Licence 1 Miashs",
          },
          bac: {
            school: "Lycee technicum de seddouk",
            bac: "Bac Scientifique (S)",
          },
        },
        experiences: {
          title: "Expérience professionnelle",
          sanofi: {
            job: "Consultant en Développeur Full Stack",
            date: "{{ date }}",
            address: "Vitry-sur-Seine, Île-de-France, France",
          },
          ls: {
            job: "Développeur Full Stack",
            contract: "CDI",
            contract1: "Contrat en alternance",
            contract2: "Stage",
            date: "{{ date }}",
            address: "Fontenay-aux-Roses, Île-de-France, France",
          },
          buffalo: {
            job: "Développeur Web",
            contract: "Buffalo Grill · Contrat en alternance",
            date: "{{ date }}",
            address: "Montrouge, Île-de-France, France",
          },
          franprix: {
            job: "Vendeur à temps partiel (job étudiant)",
            contract: "Franprix - Groupe Casino · CDI Temps partiel",
            date: "{{ date }}",
            address: "Paris, Île-de-France, France",
          },
        },
        competencies: {
          title: "Compétences",
          languages: {
            title: "Langages De Programmation",
          },
          frameworks: {
            title: "Frameworks et outils",
          },
          infras: {
            title: "CI/CD & Infrastructure",
          },
          databases: {
            title: "Bases de données",
          },
          tests: {
            title: "Test & sécurité",
          },
          projects: {
            title: "Gestion de projet",
            agile: "Méthode Agile",
          },
        },
        languagePreferences: {
          languages: {
            title: "Langues",
            english: {
              title: "Anglais",
              level: "Niveau intermédiaire",
            },
            arabic: {
              title: "Arabe",
              level: "courant",
            },
            kabyle: {
              title: "Kabyle",
              level: "langue maternelle",
            },
          },
          system: {
            title: "Préférence OS",
          },
          certificate: {
            title: "Certificat",
          },
        },
        hobbies: {
          title: "Centres D’intérêt",
          time: {
            primary:
              "J'investis mon temps libre en travaillant sur des projets personnels",
            secondary:
              "Je passe une grande partie de mon temps libre à développer des projets qui me passionnent. Cela me permet d'apprendre de nouvelles technologies et de renforcer mes compétences tout en restant créatif.",
          },
          football: {
            primary: "Football",
            secondary:
              "Le football est l'un de mes sports préférés. J'apprécie non seulement l'aspect physique du jeu, mais aussi la stratégie et l'esprit d'équipe qu'il implique.",
          },
          swimming: {
            primary: "Natation",
            secondary:
              "La natation est un excellent moyen pour moi de me détendre et de maintenir ma forme physique. C'est aussi un sport qui demande de la discipline et de la persévérance.",
          },
        },
      },
      projects: {
        js: {
          variant: {
            info: "Variant Lifepipe est une solution innovante pour l'analyse et la gestion des données génomiques.\n\nJ'ai contribué au développement de cette application en utilisant JavaScript, Node.js et React. Mes responsabilités incluaient l'intégration de fonctionnalités interactives, l'optimisation des performances et la collaboration avec des équipes multidisciplinaires pour répondre aux besoins des utilisateurs.",
          },
          microbiome: {
            info: "Microbiome Lifepipe est une plateforme dédiée à l'analyse des données microbiologiques.\n\nJ'ai participé au développement de cette application en utilisant JavaScript, Node.js et React, avec un focus sur l'implémentation de fonctionnalités front-end intuitives et la gestion efficace des flux de données.\n\nCe projet m'a permis de collaborer avec des experts en bioinformatique pour fournir des outils puissants adaptés aux chercheurs.",
          },
          ngs: {
            info: "NGS Manager est une application destinée à la gestion des données issues du séquençage génomique de nouvelle génération.\n\nJ'ai travaillé sur ce projet en contribuant au développement d'interfaces intuitives, à la gestion des flux de données complexes et à l'intégration de fonctionnalités collaboratives, tout en optimisant les performances pour les utilisateurs",
          },
          attendance: {
            info: "Le projet **Attendance Management Client** est l'interface web développée pour le projet **Attendance Management Server**.\n\nC'est une application de gestion de présence utilisant la reconnaissance faciale en temps réel pour enregistrer les présences des etudiants.\n\nL’application web est éservé aux administrateurs et comprend une page de connexion sécurisée. Seules les personnes autorisées, telles que les administrateurs, peuvent accéder à l'interface de gestion des présences.\nUne fois connectés, les administrateurs peuvent visualiser les étudiants présents en temps réel, consulter l'heure d'arrivée de chaque étudiant et générer des rapports PDF détaillant les présences pour une date spécifique ou pour la journée en cours.\n\nLa page de login garantit que seules les personnes habilitées peuvent accéder à ces fonctionnalités sensibles, assurant ainsi la confidentialité et la sécurité des données.",
          },
          procurement: {
            info: "Le projet **Procurement Guide Client** est l'interface web développée pour le projet **Procurement Guide Server**. Elle permet aux utilisateurs de saisir des avis sur des produits via un site e-commerce fictif. Les résultats de la classification des avis (positifs ou négatifs) sont uniquement accessibles aux administrateurs de l'application web.\n\nDéveloppée avec React et JavaScript, l'interface offre une expérience utilisateur intuitive pour soumettre des avis, tandis que l'API Flask du serveur traite et classifie ces avis en temps réel à l'aide d'un modèle SVM.",
          },
          portfoliov2: {
            info: "Portfolio V2 est une version améliorée et optimisée de mon portfolio, développée avec React et Material-UI. \n\nCette version intègre un design modernisé, épuré et entièrement responsive, offrant une meilleure expérience utilisateur. Elle met en avant mes projets, mes compétences et mon parcours de manière interactive, grâce à l'utilisation des composants dynamiques de Material-UI et d'animations fluides. \n\nLe code est structuré pour une maintenance simplifiée et évolutive, avec des styles modulaires basés sur SCSS pour une personnalisation accrue.",
          },
          portfoliov1: {
            info: "Ce projet consiste en la création de la version beta de mon portfolio, développé avec React et SCSS.\n\nL'application présente une interface moderne et responsive pour afficher mes projets, mes compétences et mon parcours professionnel. Elle utilise React pour une gestion efficace de l'interface utilisateur et SCSS pour un stylisme flexible et organisé.",
          },
          mincraft: {
            info: "Ce projet consiste en une version simplifiée de Minecraft, développée avec Three.js, une bibliothèque JavaScript pour la création de graphiques 3D.\n\nCe projet permettant à un joueur d’interagir avec une carte en 3D. Le joueur peut placer ou supprimer des cubes de différentes couleurs et observer un cycle jour/nuit dynamique grâce à un éclairage en mouvement.\n\nCe projet explore les bases de la manipulation 3D, de la gestion de lumière et des interactions utilisateur pour créer une expérience immersive inspirée de Minecraft.",
          },
          panolanse: {
            info: "**Panolanse** est un projet en JavaScript visant à créer une visionneuse interactive pour des images panoramiques à 360 degrés.\n\nL’application permet aux utilisateurs de naviguer librement dans les panoramas en effectuant des rotations et des zooms à l’aide de la souris ou d’interactions tactiles.\n\nCe projet a exploité des technologies comme WebGL et des bibliothèques graphiques pour gérer le rendu des images en temps réel, offrant une expérience immersive et fluide.",
          },
          kresus: {
            title: "contribution à l'application kresus",
            info: "**Kresus** est une application de gestion financière personnelle open-source qui permet aux utilisateurs de suivre leurs dépenses, d'organiser leurs finances et de visualiser leurs données sous forme de graphiques et de rapports.\n\nDans ce projet, la contribution a consisté à ajouter le support des langues espagnole et turque, en traduisant l'interface utilisateur et les messages clés pour rendre l'application accessible à un public plus large.",
          },
          TRex: {
            info: "Ce projet consiste à recréer le célèbre jeu **T-Rex** en JavaScript, inspiré du mini-jeu du navigateur Google Chrome.\n\nLe jeu met en scène un dinosaure qui doit éviter des obstacles, comme des cactus et des oiseaux, en sautant ou en se baissant.\nL’objectif est d’obtenir le meilleur score possible en survivant le plus longtemps.",
          },
          graphql: {
            title: "Graphql",
            info: "Ce projet consiste à découvrir et mettre en pratique les concepts de GraphQL avec JavaScript.\n\nIl inclut la création d'un serveur GraphQL, la définition de schémas, de requêtes et de mutations, ainsi que la manipulation de données.",
          },
        },
        py: {
          MetaPredictor: {
            info: "MetaPredictor est une application permettant de prédire les interactions entre les anticorps et les molécules MHC de classe I et II.\n\nJ'ai contribué au développement de l'API backend avec FastAPI et à la partie front-end avec React, en développant des fonctionnalités permettant de traiter et visualiser les données de prédiction de manière efficace et intuitive.",
          },
          attendance: {
            info: "Le projet **Attendance Management Server** est une application de gestion de présence utilisant la reconnaissance faciale en temps réel pour enregistrer les présences des etudiants.\n\nCette partie elle utilise la bibliothèque dlib pour la détection et l'encodage des visages, et OpenCV pour capturer et afficher les images en direct via une webcam. Lorsqu'un visage connu est détecté, il est comparé à ceux enregistrés dans une base de données Firebase. Si le visage est reconnu, le nom et l'heure de l'enregistrement sont ajoutés à la base de données, ce qui permet de suivre les présences.\n\nLe projet inclut également l'intégration avec Firebase Storage pour stocker les images et les données des visages enregistrés, ainsi qu'une gestion des données en temps réel.",
          },
          procurement: {
            info: "Le projet **Procurement Guide Server** est une application Flask dédiée à la gestion et à l'analyse des avis clients.\n\nIl collecte les avis depuis une base de données Firebase, les prétraite en supprimant les mots vides et en effectuant de la lemmatisation, puis les classe en utilisant un modèle SVM.\n\nL'API Flask expose des endpoints pour recevoir des avis clients, les classer (positifs ou négatifs), et retourner les résultats via des prédictions en temps réel, facilitant ainsi l'analyse des retours clients.",
          },
          starcraft: {
            info: "Dans ce projet **Starcraft with PySC2**, j'ai utilisé l'API PySC2 pour interagir avec le jeu Starcraft II.\n\nCe projet se concentre sur l'entraînement d'agents d'intelligence artificielle pour jouer au jeu en utilisant des techniques d'apprentissage par renforcement. J'ai créé des environnements d'entraînement et analysé les performances des agents dans différents scénarios du jeu.\n\nL'objectif est de développer une IA capable de prendre des décisions stratégiques dans le cadre de Starcraft II.",
          },
          covid: {
            title: "Analyse Covid",
            info: "Dans ce projet, j'ai analysé les données de vaccination contre le Covid-19 à l'aide de Python et de plusieurs bibliothèques comme Pandas, Seaborn, Plotly et Folium.\n\nJ'ai effectué des nettoyages de données, comblé les valeurs manquantes et réalisé diverses visualisations telles que les vaccins utilisés dans le monde, la vaccination par pays, et la prédiction du nombre de personnes vaccinées en France.\n\nCe projet inclut également la création de cartes interactives et la prédiction des tendances de vaccination à l'aide du modèle Prophet.",
          },
          ia: {
            title: "Intelligence artificielle",
            info: "J'ai développé plusieurs scripts en intelligence artificielle et machine learning.\n\nCes scripts incluent des implémentations d'algorithmes tels que K-means pour la classification, la résolution de problèmes logiques comme celui du fermier, et l'utilisation d'algorithmes de recherche tels que A* pour trouver des chemins dans des jeux simulés.\n\nMon travail explore différentes méthodes d'optimisation et de recherche, tout en appliquant ces techniques à des problèmes pratiques et théoriques pour mieux comprendre et résoudre des défis complexes.",
          },
          crypto: {
            title: "Cryptologie",
            info: "Ce projet se concentre sur la cryptographie et le chiffrement/déchiffrement de données en utilisant Python.\n\nJ'ai travaillé sur des algorithmes de sécurité tels que RSA et AES, en mettant l'accent sur la création de méthodes robustes et sécurisées pour protéger les informations sensibles. Le projet comprend l'implémentation de plusieurs techniques de cryptage, avec un focus sur l'efficacité et la simplicité d'utilisation.",
          },
          parser: {
            title: "Analyseur XML",
            info: "Ce projet Python est un script de traitement de texte qui lit un fichier texte, le nettoie et le transforme en un format XML.\n\nIl utilise des expressions régulières pour nettoyer et formater le texte avant de le convertir en phrases distinctes et de générer un fichier XML de sortie.",
          },
          flask: {
            title: "API Flask",
            info: "Ce projet consiste à apprendre à créer des APIs avec Flask, un micro-framework Python. il permet de gérer une liste de livres utilisant un fichier JSON pour stocker les données.\n\nL'API expose plusieurs routes permettant d'interagir avec ces données à travers les méthodes HTTP suivantes : GET pour récupérer la liste des livres ou un livre spécifique, POST pour ajouter un nouveau livre, PUT pour mettre à jour un livre existant, et DELETE pour supprimer un livre de la liste.",
          },
        },
        ccplus: {
          tetris: {
            info: "Ce projet consiste en l'implémentation du jeu Tetris en langage C++.\n\nLe jeu suit les règles classiques de Tetris, où le joueur doit organiser des formes géométriques (appelées 'tetriminos') tombant du haut de l'écran pour former des lignes complètes, qui seront alors supprimées. À mesure que le joueur progresse, le niveau change dynamiquement, modifiant la forme de la matrice de jeu qui peut prendre des configurations variées comme un triangle, un carré ou un rectangle.\n\nDe plus, la difficulté augmente avec le temps en accélérant la vitesse des formes tombantes, offrant un défi supplémentaire et rendant l'expérience plus immersive.",
          },
          uno: {
            info: "Ce projet consiste en l'implémentation du jeu de cartes UNO en langage C.\n\nLe jeu respecte les règles classiques d'UNO, où les joueurs doivent se débarrasser de leurs cartes en suivant les règles de couleur ou de valeur, avec l'ajout de cartes spéciales qui modifient le cours du jeu (comme les cartes 'Plus 2', 'Inverser', 'Passer', etc.).",
          },
          grenoble: {
            title: "Tramway De Grenoble",
            info: "Ce projet vise à implémenter un système de gestion de trajets de tramway dans la ville de Grenoble, en utilisant l'algorithme de recherche A* pour déterminer le chemin le plus court entre une station de départ et une station d'arrivée.\n\nL'objectif est de fournir un itinéraire optimal pour un voyage en tram, en tenant compte des différentes stations et des escales possibles, tout en minimisant la distance ou le temps de trajet.",
          },
          antColony: {
            title: "Fourmilière",
            info: "Ce projet implémente un algorithme de colonies de fourmis (Ant Colony Optimization, ACO) en langage C, une technique inspirée du comportement des fourmis dans la nature pour résoudre des problèmes d'optimisation combinatoire.\n\nL'objectif est de simuler une colonie de fourmis qui explore un environnement pour trouver des solutions optimales à des problèmes complexes, comme le problème du voyageur de commerce (TSP).",
          },
          som: {
            title: "Carte Autoadaptative",
            info: "Les cartes autoadaptatives, cartes auto-organisatrices ou cartes topologiques forment une classe de réseau de neurones artificiels fondée sur des méthodes d'apprentissage non supervisées.",
          },
          storage: {
            title: "Stockage memoire",
            info: "Ce projet a été réalisé dans le but d'apprendre et de comprendre la gestion de la mémoire en langage C, notamment la gestion dynamique de la mémoire, l'allocation et la libération des ressources.\n\nL'objectif était de créer un système de stockage mémoire personnalisé, permettant de gérer efficacement l'allocation, la lecture, et la libération de blocs de mémoire.",
          },
          graphique: {
            title: "Conception Graphique",
            info: "Ces projets ont été réalisé dans le cadre de l'apprentissage de la création d'interfaces graphiques en utilisant GL4Dummies",
          },
          LearCplus: {
            title: "Apprendre C/C++",
            info: "J'ai développé une collection d'algorithmes et de structures de données implémentés en C et C++.\n\nCe projet a été conçu pour renforcer ma maîtrise de ces langages en abordant des concepts fondamentaux de la programmation, tels que la gestion de la mémoire, les pointeurs, et les algorithmes classiques.\n\nChaque fichier présente un algorithme ou une structure de données avec des exemples d'application et des explications détaillées, permettant aux utilisateurs d'apprendre et de comprendre les bases de C et C++ à travers des exercices pratiques.",
          },
        },
        java: {
          snake: {
            info: "Un joueur contrôle un serpent qui grandit à chaque fois qu'il mange de la nourriture.\n\nLe but du jeu est de manger autant de nourriture que possible sans percuter les murs ou se mordre soi-même.",
          },
          quiz: {
            info: "Ce projet est un jeu de quiz réalisé en Kotlin.\nLe joueur peut choisir une catégorie de quiz et répondre à des questions pour marquer des points.\n\nDans ce jeu j'ai utilisé une base de données Firebase pour stocker les questions et les réponses.",
          },
          som: {
            title: "Carte Autoadaptative",
            info: "Ce projet consiste à développer une carte auto-organisatrice (SOM) en Java.\n\nL'accent est mis sur l'algorithme d'apprentissage non supervisé pour ajuster les neurones en fonction des données, permettant de suivre l'évolution du modèle",
          },
          springBoot: {
            info: "j'ai réalisé plusieurs mini-projets afin de tester l'intégration de diverses solutions côté client, côté serveur et au niveau des bases de données.\n\nL'objectif était de me familiariser avec différentes architectures et d'analyser les avantages et les défis associés à chaque technologie. \n\nJ'ai travaillé principalement avec Spring Boot pour le backend, en l'associant à des bases de données relationnelles comme MySQL et des bases de données NoSQL telles que MongoDB, afin de tester leur capacité à gérer des flux de données variés et leur efficacité dans des environnements de développement modernes.\n\nSur le côté client, j'ai comparé deux frameworks populaires : React et Angular. Ces technologies m'ont permis de tester différentes approches de développement d'interfaces utilisateur réactives et dynamiques.",
          },
        },
        other: {
          title: "Autre",
          search: {
            info: "Ce projet consiste à développer un moteur de recherche qui analyse différents types de documents (HTML, TXT, PDF). Lorsqu'un utilisateur entre un mot-clé, le système identifie dans quels fichiers il apparaît.\n\nLe projet inclut l'extraction des métadonnées (keywords, description) et du titre des documents, ainsi que le découpage du texte en éléments.\n\nUn filtrage par taille est effectué sur les éléments, et le système calcule les occurrences de chaque mot pour améliorer la pertinence des résultats. Les données sont stockées dans une base de données MySQL pour faciliter la gestion des fichiers et des résultats.",
          },
          php: {
            title: "Angular Avec Php",
            info: "Ce projet a été développé pour apprendre et intégrer Angular côté frontend et PHP côté backend, en mettant l'accent sur la communication entre ces deux technologies via des API RESTful.\n\nL'objectif était de comprendre comment les applications modernes utilisent Angular pour créer des interfaces dynamiques et comment PHP peut être utilisé pour fournir des données et interagir avec une base de données Mysql.",
          },
          smart: {
            title: "Smart Contrat",
            info: "Ce projet a été réalisé dans le but d'apprendre et de comprendre le développement de Smart Contracts sur la blockchain Ethereum en utilisant le langage Solidity.\n\nL'objectif était de se familiariser avec les principes fondamentaux des contrats intelligents, leur déploiement sur la blockchain, ainsi que l'interaction avec ces contrats via des interfaces utilisateurs et des outils comme Truffle et Metamask.",
          },
          native: {
            title: "React Native",
            info: "Ce projet a été conçu pour apprendre à développer une application mobile avec React Native.\n\nL'objectif principal était de créer une application simple qui permet aux utilisateurs de se connecter, de créer un compte, et de se déconnecter, en mettant l'accent sur la gestion de l'authentification et de l'état de l'utilisateur. ",
          },
          assembly: {
            title: "Assembleur",
            info: "Ces projets ont été conçu pour apprendre les bases de la programmation en Assembleur.\n\nL'objectif était de comprendre comment manipuler directement le processeur et la mémoire d'un ordinateur, ainsi que de réaliser des opérations simples telles que l'addition et la soustraction à un niveau bas.",
          },
        },
        button: "Voir plus",
        linkButton: "jetez y un oeil",
      },
      contact: {
        title: "Contactez-nous",
      },
      footer: {
        copyright: "© {{year}}.",
        legalNotice: "Mentions légales",
      },
      legalNotice: {
        title: "Mentions Légales",
        companyInfo: "Éditeur du site",
        companyName: "Nom Complet : Karim AIT EL DJOUDI ",
        phone: "Téléphone : +33 769632389",
        email: "Email: aiteldjoudikarim06@gmail.com",
        /*----------------- Hébergeur ------------------*/
        host: "Hébergeur",
        hostDetails:
          "Pour assurer la fiabilité et la sécurité de nos services en ligne, nous travaillons avec un hébergeur de confiance. Voici les détails de notre hébergeur :",
        hostName: "Amazon Web Services (AWS)",
        hostAddress:
          "Amazon Web Services, Inc. 410 Terry Avenue North, Seattle, WA 98109-5210, États-Unis",
        hostPhone: "+1 206-266-4064",
        website: "https://aws.amazon.com",
        /*----------------- dataPolicy ------------------*/
        dataPolicy: "Politique de données",
        dataPolicyDetails:
          "Sur ce site, nous respectons votre vie privée et nous prenons la protection de vos données personnelles très au sérieux. Nous ne stockons aucune donnée personnelle.",
        copyRestrictions: "Restrictions de copie",
        copyRestrictionsDetails:
          "La propriété intellectuelle est une valeur que nous défendons avec fermeté. Toute tentative de copier ou de reproduire notre site web, en tout ou en partie, constitue une violation de nos droits d'auteur et est strictement interdite. Article L.335-2.",
        photoCredit: "Crédit photos",
        photoCreditDetails:
          "Les images utilisées sur ce site proviennent de Freepik ainsi que de logos et visuels issus de collaborations professionnelles avec des entreprises et institutions universitaires, qui restent la propriété exclusive de leurs titulaires. Pour toute demande de modification ou de retrait, veuillez me contacter par e-mail. ",
      },
    },
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "fr",
  fallbackLng: "fr",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
